import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import CustomSelect from "../Common/CustomSelect";

function CatalogProductSorting({ sortOptions, sortCallback }) {
  const [searchParams] = useSearchParams();
  const selected_sort_by = searchParams.get("sort-by") || "";
  const [appliedSortBy] = useState(selected_sort_by);
  const onSortItemClick = (id, title) => {
    // setAppliedSortBy(title);
    if (id !== appliedSortBy) {
      sortCallback(id);
    }
  };
  return (
    <div className="sort-by-dropdown">
      <CustomSelect
        options={sortOptions?.map(({ title, id }) => {
          return { value: id, label: title };
        })}
        onChange={(e) => onSortItemClick(e.value, e.label)}
        defaultValue={appliedSortBy}
        placeholder={"Sort By"}
      />

      {/* <div className="dropdown">
        <button
          className="btn dropdown-toggle"
          type="button"
          id="dropdownMenuButton1"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {appliedSortBy}
        </button>
        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            {sortOptions?.map(({title, id}) => {
                return (
                  <li key={id} onClick={() => onSortItemClick(id, title)}>
                    <a className="dropdown-item" href="#0">
                      {title}
                    </a>
                  </li>
                );
            })}
        </ul>
      </div> */}
    </div>
  );
}

export default CatalogProductSorting;
